import React from 'react';
import { connect } from 'react-redux';

import './DesignItem.css';

class DesignItem extends React.Component {
  render() {
    return (
      <div className="design-card">
        <div className="design-card-inner">
          <div
            className="preview-image"
            style={{
              backgroundImage:
                'url(https://app.getpaddee.com/images/placeholder.png)'
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  {}
)(DesignItem);



// WEBPACK FOOTER //
// ./src/components/DesignItemPlaceholder.js